import { authenticatedFetch } from '../utils/api';
import { API_HOST } from '../utils/constants';

export async function recycleStoredMedia({ projectId, episodeId, url } = {}) {
  const project = Number(projectId);
  const episode = episodeId == null || episodeId === '' ? null : Number(episodeId);
  if (!Number.isSafeInteger(project) || project <= 0 || (episode != null && (!Number.isSafeInteger(episode) || episode <= 0))) {
    throw new Error('缺少有效的原项目或集数信息，请重新加载记录后再移入回收站。');
  }
  if (typeof url !== 'string' || !url.trim()) throw new Error('缺少原始媒体地址，未执行删除。');
  let result;
  try {
    result = await authenticatedFetch(`${API_HOST}/api/resources/recycle`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ projectId: project, ...(episode != null ? { episodeId: episode } : {}), url }),
    });
  } catch (error) {
    if (Number(error?.status || error?.code) === 409) throw new Error('媒体记录尚未保存完成，请稍后刷新再试。当前卡片已保留。');
    throw error;
  }
  if (!Number.isSafeInteger(result?.count) || result.count <= 0) throw new Error('未确认媒体记录已移入回收站，请刷新核实。当前卡片已保留。');
  return result;
}
